import React, { useMemo, useState } from "react";
import { Button, Modal, Tooltip } from "antd";
import { useQueryGeneratorContext } from "../../context/QueryBuilder/QueryGeneratorContext";
import "./ResetQueriesModal.css";

const ResetQueriesModal = () => {
  const { handleOnQueriesRestore, handleOnResetAll, queriesData, selectedTableNames } = useQueryGeneratorContext();
  const selectedValuesLength = (queriesData?.selected_values?.length || 0)
  const isEditMode = queriesData?.id && selectedValuesLength > 0;

  const [isOpen, setIsOpen] = useState(false)

  const isResetButtonDisabled = useMemo(
    () =>
      selectedValuesLength < 1 &&
      selectedTableNames?.length < 1,
    [selectedValuesLength, selectedTableNames?.length]
  );

  const handleOnReset = () => {
    handleOnQueriesRestore();
    setIsOpen(false)
  };
  
  const handleOnResetAllClick = () => {
    handleOnResetAll()
    setIsOpen(false)
  }

  return (
    <>
      <Tooltip title={isResetButtonDisabled ? 'No saved configuration to reset.': ''}>
        <Button variant="outlined" className="reset-btn" onClick={() => setIsOpen(true)} disabled={isResetButtonDisabled}>
          Reset
        </Button>
      </Tooltip>
      <Modal
        title="Are you sure you want to reset?"
        open={isOpen}
        footer={false}
        onCancel={() => setIsOpen(false)}
        // onClose={() => setIsOpen(false)}
        centered
        className="custom-reset-modal"
        closable={false}
      >
        <p>
          All your unsaved changes will be removed and previous changes will be
          restored if any.
        </p>
        <div className="d-flex flex-row-reverse">
          <div className="d-flex gap-1">
            <Button onClick={() => setIsOpen(false)} className="reset-btn" style={{fontSize: '14px'}}>Cancel</Button>
            {isEditMode && <Button onClick={handleOnReset}>Revert to Last Save</Button>}
            <button type='button' onClick={handleOnResetAllClick} className="btn  btn-sm reset-all-btn" style={{backgroundColor: "rgb(2, 78, 248)", color:"#FFF"}}>Reset All</button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ResetQueriesModal;
